import { render, staticRenderFns } from "./CAxAFFxBasicHabitsPage.vue?vue&type=template&id=3badab97"
import script from "./CAxAFFxBasicHabitsPage.vue?vue&type=script&lang=js"
export * from "./CAxAFFxBasicHabitsPage.vue?vue&type=script&lang=js"
import style0 from "./CAxAFFxBasicHabitsPage.vue?vue&type=style&index=0&id=3badab97&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports